/**
 * Deep links for admin chat navigation (investor tabs, chat query params).
 * See docs/ADMIN_CHAT_ENTITY_LINKS.md
 */
export interface ChatDeepLinkContext {
  screen: string;
  fundOpportunityExternalId?: string | null;
  investorExternalId?: string | null;
}

export function chatQueryParams(conversationId: string): string {
  return `chat=open&chatId=${encodeURIComponent(conversationId)}`;
}

export function chatTranscriptQueryParams(conversationId: string): string {
  return `chat=transcript&chatId=${encodeURIComponent(conversationId)}`;
}

export function investorTabForStatus(status: string): 'eoi' | 'fund-update' {
  return status === 'LEAD' || status === 'OPPORTUNITY' ? 'eoi' : 'fund-update';
}

export function buildInvestorChatDeepLink(
  fundOpportunityExternalId: string,
  investorExternalId: string,
  investorStatus: string,
  conversationId: string,
): string {
  const tab = investorTabForStatus(investorStatus);
  return `/opportunities/${fundOpportunityExternalId}/investors/${investorExternalId}?tab=${tab}&${chatQueryParams(conversationId)}`;
}

export function buildEntityChatDeepLink(entityExternalId: string, conversationId: string): string {
  return `/investment-entities/${entityExternalId}?${chatQueryParams(conversationId)}`;
}

export function buildContextDeepLink(
  context: ChatDeepLinkContext | null,
  contactExternalId: string,
  conversationId: string,
): string | null {
  if (!context || !contactExternalId) return null;
  const chatParams = chatQueryParams(conversationId);
  const investorId = context.investorExternalId ?? contactExternalId;
  if (context.screen === 'eoi' && context.fundOpportunityExternalId) {
    return `/opportunities/${context.fundOpportunityExternalId}/investors/${investorId}?tab=eoi&${chatParams}`;
  }
  if (context.screen === 'fund_update' && context.fundOpportunityExternalId) {
    return `/opportunities/${context.fundOpportunityExternalId}/investors/${investorId}?tab=fund-update&${chatParams}`;
  }
  if (context.screen === 'portfolio') {
    return `/contacts/${contactExternalId}/portfolio?${chatParams}`;
  }
  if (context.screen === 'new_funds') {
    return `/contacts/${contactExternalId}/opportunities?${chatParams}`;
  }
  if (context.screen === 'home') {
    return `/contacts/${contactExternalId}/overview?${chatParams}`;
  }
  return `/contacts/${contactExternalId}?${chatParams}`;
}
